import { TPermission } from 'types/permissions'
import { TRole, TRoleWithPermissions } from 'types/roles'

export const transfromRolesToRolesWithPermissions = (
  userRoles: TRole[],
  permissions: TPermission[]
) => {
  return (
    userRoles?.reduce((acc: TRoleWithPermissions[], cur: TRole): TRoleWithPermissions[] => {
      const filteredPermissionsByRoleUuid = permissions?.filter(
        (permission) => permission.userRoleId === cur.uuid
      )
      return [...acc, { ...cur, permissions: filteredPermissionsByRoleUuid ?? [] }]
    }, []) ?? []
  )
}
